import React, { Component } from 'react';
import styled from 'styled-components';

import { stylesFor } from '../styles/utilities';

const Root = styled.div`
  align-items: flex-start;
  color: ${props => props.theme.color.gray19};
  display: flex;
  margin-bottom: 20px;

  ${stylesFor.xLargeUp`
    break-inside: avoid-column;
    padding-bottom: 80px;
    padding-right: 160px;
  `};
`;

const Image = styled.img`
  height: 64px;
  margin-right: 72px;
  width: 64px;

  ${stylesFor.underXLarge`
    display: none;
  `};
`;

const Chevron = styled.div`
  ${stylesFor.underXLarge`
    cursor: pointer;
    left: -4px;
    padding: 8px;
    position: absolute;
    top: ${props => (props.isExpanded ? '-9px' : '-7px')};
    transform: ${props =>
      props.isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)'};
    transition: all 0.1s linear;
  `};

  ${stylesFor.xLargeUp`
    display: none;
  `};
`;

const Text = styled.div`
  font-size: 14px;
  height: auto;
  overflow: hidden;
  position: relative;

  ${stylesFor.underXLarge`
    max-height: ${props => (props.isExpanded ? '240px' : '24px')};
    padding-left: 20px;
    transition: max-height 0.2s linear;
  `};

  ${stylesFor.xLargeUp`
    font-size: 20px;
  `};
`;

const Name = styled.span`
  display: block;
  font-size: 14px;
  font-weight: ${props => props.theme.font.weight.semibold};
  margin-bottom: 8px;

  ${stylesFor.mediumUp`
    font-size: 16px;
  `};

  ${stylesFor.underXLarge`
    cursor: pointer;
  `};

  ${stylesFor.xLargeUp`
    font-size: 18px;
  `};
`;

const Description = styled.p`
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  max-width: 40rem;

  ${stylesFor.mediumUp`
    font-size: 16px;
  `};

  ${stylesFor.xLargeUp`
    font-size: 18px;
  `};
`;

export default class Principle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: this.props.isExpanded,
    };
  }

  render() {
    const { icon, name, description } = this.props;
    const { isExpanded } = this.state;

    return (
      <Root>
        <Image src={icon} />
        <Text isExpanded={isExpanded}>
          <Chevron
            isExpanded={isExpanded}
            onClick={() => this.setState({ isExpanded: !isExpanded })}
          >
            <img src="images/chevronSmall.svg" width="8" height="5" />
          </Chevron>
          <Name onClick={() => this.setState({ isExpanded: !isExpanded })}>
            {name}
          </Name>
          <Description>{description}</Description>
        </Text>
      </Root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/principle.js